import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a92af33c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password" }
const _hoisted_2 = { class: "displayflex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_unlock_outlined = _resolveComponent("unlock-outlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_check_circle_outlined = _resolveComponent("check-circle-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showflag)
      ? (_openBlock(), _createBlock(_component_a_row, {
          key: 0,
          class: "item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: "",
                      style: {"width":"100%"}
                    }, _ctx.validateInfos.password), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.modelRef.password,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.password) = $event)),
                          placeholder: _ctx.t('page.personal.center.compontent.oldpassword.tips')
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_component_unlock_outlined)
                          ]),
                          _: 1
                        }, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 16),
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: "",
                      style: {"width":"100%"}
                    }, _ctx.validateInfos.newPassword), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.modelRef.newPassword,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.newPassword) = $event)),
                          placeholder: _ctx.t('page.personal.center.compontent.newpassword.tips')
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_component_unlock_outlined)
                          ]),
                          _: 1
                        }, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 16),
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: "",
                      style: {"width":"100%"}
                    }, _ctx.validateInfos.newPassword2), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.modelRef.newPassword2,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.newPassword2) = $event)),
                          placeholder: _ctx.t('page.personal.center.compontent.confirmpassword.tips')
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_component_unlock_outlined)
                          ]),
                          _: 1
                        }, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 16),
                    _createVNode(_component_a_row, { class: "displayflex" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _ctx.handleSubmit
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.psd.btnconfirm')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_a_button, { onClick: _ctx.handleCtrl }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.btnctrl')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_a_row, {
          key: 1,
          class: "item-t"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_check_circle_outlined, { class: "icon-b" }),
              _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.txtstart')) + _toDisplayString(_ctx.count) + _toDisplayString(_ctx.t('page.personal.center.compontent.txtend')), 1)
            ]),
            _createVNode(_component_a_button, {
              type: "primary",
              style: {"margin-top":"20px","width":"40%"},
              onClick: _ctx.handleLogin
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.login')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
  ]))
}